import React, { useState } from 'react'
import { z } from "zod"
import { FieldPath } from "react-hook-form"
import {
  FormControl,
  FormField,
  FormLabel,
  FormMessage
} from "@/components/ui/form"
import { Control } from 'react-hook-form'
import { Input } from "@/components/ui/input"
import { cn, tripFormSchema } from '@/lib/utils'

const formSchema = tripFormSchema();


interface CustomInputProps {
    control: Control<any>,
    name: FieldPath<any>,
    label: string,
    placeholder: string,
    inputType?: string
}


const CustomInput = ({ control, name, label, placeholder, inputType }:CustomInputProps) => {
  return (
    <FormField
        control={control}
        name={name}
        render={({ field }) => (
        <div className='form-item'>
            <FormLabel className={cn('form-label', 'pl-2')}>
                {label}
            </FormLabel>
            <div className='flex w-full flex-col'>
                <FormControl>
                    <Input placeholder={placeholder} 
                        className='input-class'
                        
                        type={inputType ?? 'text'}
                        {...field}/>
                </FormControl>
                <FormMessage className='form-message mt-2' />
            </div>
        </div>
    )}
    />
  )
}

export default CustomInput
